module.exports = __webpack_public_path__ + "static/media/telecoms-fibre.b51b347f.svg";